import { CircularProgress } from "@mui/material";
import { t } from "../../../../translations";

const OtpStep = ({
  phoneNumber,
  otp,
  setOtp,
  otpLoading,
  setShowOtpStep,
  selectedLang,
  onVerifyOtp,
  onResendOtp
}) => {
  return (
    <div className="log-in-up-menu">
      <h2>{t("navbar.otp_verify", selectedLang)}</h2>
      <p style={{ fontSize: "14px", margin: "10px 0", color: "#666" }}>
        {t("navbar.otp_sent_message", selectedLang)} {phoneNumber}
      </p>
      <input
        placeholder={t("navbar.otp_enter", selectedLang)}
        value={otp}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, "").slice(0, 6);
          setOtp(value);
        }}
        type="text"
        maxLength="6"
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
          textAlign: "center",
          fontSize: "18px",
          letterSpacing: "2px"
        }}
      />
      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <button
          className="btn-email"
          onClick={onVerifyOtp}
          disabled={otpLoading || otp.length !== 6}
          style={{
            flex: 1,
            opacity: otpLoading || otp.length !== 6 ? 0.6 : 1,
            cursor: otpLoading || otp.length !== 6 ? "not-allowed" : "pointer"
          }}
        >
          {otpLoading ? (
            <CircularProgress size={20} />
          ) : (
            t("navbar.verify_otp", selectedLang)
          )}
        </button>
        <button
          className="btn-email"
          onClick={onResendOtp}
          disabled={otpLoading}
          style={{
            flex: 1,
            opacity: otpLoading ? 0.6 : 1,
            cursor: otpLoading ? "not-allowed" : "pointer",
            backgroundColor: "#f0f0f0",
            color: "#333"
          }}
        >
          {t("navbar.otp_resend", selectedLang)}
        </button>
      </div>
      <button
        onClick={() => setShowOtpStep(false)}
        style={{
          background: "none",
          border: "none",
          color: "#666",
          cursor: "pointer",
          marginTop: "10px",
          textDecoration: "underline"
        }}
      >
        {t("navbar.back_to_form", selectedLang)}
      </button>
    </div>
  );
};

export default OtpStep;
